var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('title1',{attrs:{"type":"1","title":"总电量&电价","subTitle":"Electric Port Overview"}}),_c('div',{staticStyle:{"width":"565px","height":"325px"}},[(_vm.showcdata)?_c('MyEcharts',{attrs:{"id":'zongdianliangjidianjia233456',"options":_vm.cdata}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }